import { useRef, useState } from "react";
import { FileActionButton } from "../file-action/file-action-controls";
import { generateProductSummaryPDF } from "../Driver-DeliveryDetails/DeliveryChallanPDF";
import orderServices from "../../services/orders/orderservice";
import type { ChallanProducts } from "../../models/Delivery-Executive/DeliveryExecutive";

export default function PreChallanExportButton({ orderIds }: { orderIds: string[] }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const working = useRef(false);
  const exportFile = async () => {
    if (working.current || !orderIds.length) return;
    working.current = true; setBusy(true); setError("");
    try {
      const [response, vesselDetails] = await Promise.all([
        orderServices.getPreChallanProducts(orderIds.map(Number)), orderServices.getVesselDetails(orderIds),
      ]);
      const products = response as unknown as Partial<ChallanProducts>;
      if (!products || (!products.categorySummaries?.length && !products.lineItems?.length))
        throw new Error("No PreChallan details available. Please retry.");
      await generateProductSummaryPDF({ categorySummaries: products.categorySummaries || [], lineItems: products.lineItems || [],
        drivername: products.drivername || "", vesselDetails: vesselDetails || [] });
    } catch { setError("Unable to export PreChallan. Please retry."); }
    finally { working.current = false; setBusy(false); }
  };
  return <div><FileActionButton action="export" label="Export PreChallan" icon="pi pi-download" outlined size="small"
    disabled={!orderIds.length || busy} loading={busy} onClick={() => void exportFile()} />
    {error && <small role="alert">{error}</small>}</div>;
}
